// extracted by mini-css-extract-plugin
module.exports = {"community":"Community_community__1djiN","link":"Community_link__1YNi3","load":"Community_load__3Gyvn"};